import SearchParamsBase from "../../../Elements/SearchParamsBase";
import InputTypesEnum from "../../../Enums/InputTypesEnum";

export default class SurveySearchParams extends SearchParamsBase
{
	initialize()
	{
		this.SurveyDataId="";
		this.SurveyId="";
		this.ShopperId="";
		this.Emailrecipients="";
		this.IsActive="";
	}

	//-------------------------------------------
	//-------- Fields for Search Panel ----------
	//-------------------------------------------

	static fieldsInSearchBox=[
		{fieldName:"SurveyDataId",label:"SurveyDataId", className:"col-3", type: InputTypesEnum.Number},
		{fieldName:"SurveyId",label:"SurveyId", className:"col-3", type: InputTypesEnum.Number},
		{fieldName:"ShopperId",label:"ShopperId", className:"col-3", type: InputTypesEnum.Number},
		{fieldName:"Emailrecipients",label:"Emailrecipients", className:"col-3", type: InputTypesEnum.Text},
		{fieldName:"IsActive",label:"IsActive", className:"col-3", type: InputTypesEnum.EmptyYesNoSelect},
	];

	static iconName="fa-solid fa-search";
	static saveType = "SurveySearchParams";

	//---------------------------
	
}